import React from "react";
import { Link } from "react-router-dom";
import onboarding_layer_one from "../../assets/images/onboardingSteponeBackground.png";
import onboarding_layer_two from "../../assets/images/onboardingSteponelogo.png";
import appleIcon from "../../assets/icons/apple.svg";
import googleIcon from "../../assets/icons/google.svg";

const STORE_LINKS = {
  ios: "https://apps.apple.com/za/app/80eight/id6742113555",
  android: "https://play.google.com/store/apps/details?id=com.eighty80",
};

const StoreButton = ({ href, icon, eyebrow, label, helperText }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className="group flex w-full items-center gap-4 rounded-[28px] border border-white/12 bg-white/[0.04] px-5 py-4 text-left backdrop-blur-sm transition duration-300 hover:-translate-y-0.5 hover:border-white/25 hover:bg-white/[0.08]"
  >
    <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-white text-black transition duration-300 group-hover:scale-105">
      <img src={icon} alt="" className="h-7 w-7" aria-hidden="true" />
    </span>
    <span className="flex min-w-0 flex-col">
      <span className="font-DMMono text-[12px] uppercase tracking-[0.18em] text-white/45">
        {eyebrow}
      </span>
      <span className="font-plusjakarta text-[20px] font-semibold leading-[120%] text-white">
        {label}
      </span>
      <span className="font-plusjakarta text-sm text-white/60">
        {helperText}
      </span>
    </span>
  </a>
);

const WelcomeBanner = () => (
  <div className="max-w-[300px] rounded-full px-4 module-border-wrap-onboarding">
    <div className="module !bg-black">
      <h2 className="px-[15px] py-[5px] font-DMMono text-[14px] font-normal leading-[140%] tracking-[-0.02em] text-white/70 lg:text-[17.44px]">
        Welcome to 80eight
      </h2>
    </div>
  </div>
);

export default function DposDownload() {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="relative flex min-h-screen flex-col overflow-hidden">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(87,36,156,0.35),transparent_35%),radial-gradient(circle_at_bottom,rgba(235,51,102,0.18),transparent_28%)]" />

        <div className="relative z-10 mx-auto flex w-full max-w-[1120px] flex-1 flex-col justify-center px-6 py-10 lg:px-10">
          <div className="grid items-center gap-12 lg:grid-cols-[1.05fr_0.95fr]">
            <div className="flex flex-col items-center text-center lg:items-start lg:text-left">
              <div className="relative mb-8 flex h-[220px] w-full max-w-[340px] items-center justify-center overflow-hidden lg:mb-10 lg:h-[320px] lg:max-w-[420px]">
                <img
                  src={onboarding_layer_one}
                  alt=""
                  aria-hidden="true"
                  className="absolute w-[320px] scale-[1.55] pulse-brightness lg:w-[420px] lg:scale-[1.4]"
                />
                <img
                  src={onboarding_layer_two}
                  alt="80eight logo"
                  className="relative z-10 h-[132px] w-[132px] lg:h-[168px] lg:w-[168px]"
                />
              </div>

              <WelcomeBanner />

              <div className="mt-6 max-w-[620px]">
                <p className="font-DMMono text-[12px] uppercase tracking-[0.28em] text-white/40">
                  88Pay
                </p>
                <h1 className="mt-4 bg-[linear-gradient(273.9deg,#EB3366_18.84%,#57249C_31.98%,#00FFFF_45.13%,rgba(255,255,255,0.92)_65.02%,rgba(255,255,255,0.3)_89.89%)] bg-clip-text font-plusjakarta text-[44px] font-semibold leading-[100%] tracking-[-0.04em] text-transparent lg:text-[72px]">
                  Payments that start in the app.
                </h1>
                <p className="mt-6 font-plusjakarta text-[18px] font-light leading-[150%] tracking-[-0.02em] text-white/72 lg:max-w-[560px] lg:text-[20px]">
                  Download the 80eight app to use 88Pay.
                </p>
              </div>
            </div>

            <div className="rounded-[32px] border border-white/10 bg-white/[0.03] p-6 shadow-[0_40px_120px_rgba(0,0,0,0.45)] backdrop-blur-sm lg:p-8">
              <div className="mb-8">
                <p className="font-DMMono text-[12px] uppercase tracking-[0.22em] text-white/45">
                  Get the app
                </p>
                <h2 className="mt-3 font-plusjakarta text-[30px] font-semibold leading-[110%] tracking-[-0.03em] text-white lg:text-[38px]">
                  Open 88Pay on your phone.
                </h2>
                <p className="mt-3 font-plusjakarta text-base leading-[150%] text-white/60">
                  Install 80eight on iPhone or Android, then return to this link
                  from your mobile device.
                </p>
              </div>

              <div className="space-y-4">
                <StoreButton
                  href={STORE_LINKS.ios}
                  icon={appleIcon}
                  eyebrow="iPhone"
                  label="Apple App Store"
                  helperText="Download 80eight for iOS"
                />
                <StoreButton
                  href={STORE_LINKS.android}
                  icon={googleIcon}
                  eyebrow="Android"
                  label="Google Play Store"
                  helperText="Download 80eight for Android"
                />
              </div>

              <div className="mt-8 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/landing"
                  className="inline-flex min-h-[56px] items-center justify-center rounded-full bg-white px-6 font-plusjakarta text-[16px] font-medium text-black transition duration-300 hover:bg-white/90"
                >
                  Explore 80eight
                </Link>
                <a
                  href="https://www.80eight.io"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex min-h-[56px] items-center justify-center rounded-full border border-white/15 px-6 font-plusjakarta text-[16px] font-medium text-white transition duration-300 hover:border-white/30 hover:bg-white/[0.04]"
                >
                  Visit 80eight.io
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
